import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

// One-time reset (Oct 2026): older code saved "dark" for visitors who never chose
// it, so everyone starts on light once. Runs at import, before any page reads the
// theme. A choice made after this sticks.
try {
  if (!localStorage.getItem("scope180-theme-light-default")) {
    localStorage.setItem("scope180-theme", "light");
    localStorage.setItem("scope180-theme-light-default", "1");
  }
} catch { /* storage blocked: pages fall back to light */ }

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(
    // Default to light for first-time visitors; a returning user keeps whatever
    // they last chose (persisted in localStorage) until they toggle again.
    () => { try { return localStorage.getItem("scope180-theme") || "light"; } catch { return "light"; } }
  );

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("scope180-theme", theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
